<template>
  <el-container class="layer-detach-file">
    <el-aside width="220px">
      <left-tree @onChange="handleNodeChange" @empty="emptyTableData" />
    </el-aside>
    <el-main>
      <div class="top">
        <el-button v-if="addLayerShow" type="primary" size="small" plain :disabled="!currentNodeData" @click="addLayer">
          添加图层
        </el-button>
        <el-button v-if="delLayerShow" type="primary" size="small" plain :disabled="!selectlayers.length" @click="delLayer">
          删除
        </el-button>
      </div>
      <div class="content">
        <el-table v-loading="loading" :data="tableData" border element-loading-text="数据加载中" height="100%"
          highlight-current-row style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55px" align="center"></el-table-column>
          <el-table-column prop="layerName" label="图层名" min-width="130px" show-overflow-tooltip />
          <el-table-column prop="lineType" label="线型" min-width="150px" show-overflow-tooltip />
          <el-table-column prop="lineWeight" label="线宽" min-width="100px" align="center" />
          <el-table-column prop="colour" label="颜色" min-width="100px" align="center" />
          <el-table-column prop="remark" label="备注" min-width="100px" align="center" />
        </el-table>
      </div>

      <el-dialog v-dialogDrag :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false"
        title="添加图层" width="700px">
        <span>
          <div class="search-header" style="margin-bottom:10px;">
            <el-input v-model="layerSearchInput" placeholder="请输入图层名称" style="width:200px" size="small" clearable
              @input="search">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <el-table ref="multipleTable" :data="layerList" border tooltip-effect="dark" style="width: 100%" height="210"
            row-key="layerId" @selection-change="selectionChangeLayer">
            <template slot="empty">
              <img :src="zanwu" style="height:100px" />
              <p style="font-size:15px;color:#000;">暂无数据</p>
            </template>
            <el-table-column type="selection" width="55px" :reserve-selection="true" align="center" />
            <el-table-column prop="layerName" label="图层名" align="center" />
          </el-table>
        </span>

        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="visible = false">取 消</el-button>
          <el-button v-preventReClick :disabled="!layerGouList.length" type="primary" size="small" @click="submit">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import leftTree from "./components/leftTree.vue";
import { mapState } from "vuex";
import layerDetachFileService from "@/CommonDP/service/layerDetachFile-service";
import { checkPermission } from "@/CommonDP/utils/routeAuth";

export default {
  name: "LayerDetachFile",
  components: {
    leftTree
  },
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      loading: false,
      visible: false,
      tableData: [],
      currentNodeData: null,
      currentSpecId: null,
      selectlayers: [],
      layerSearchInput: '',
      layerList: [],
      layerSearchList: [],
      layerGouList: [],
      addLayerShow: checkPermission(this.$allPerms.LAYERDETACHFILE_ADDLAYER),
      delLayerShow: checkPermission(this.$allPerms.LAYERDETACHFILE_DELLAYER)
    };
  },

  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  watch: {
    currentNodeData() {
      this.fetchData();
    },
    layerSearchInput(newValue) {
      if (!newValue) {
        this.layerList = this.layerSearchList;
      }
    }
  },
  methods: {
    search() {
      const { layerSearchInput: name } = this;
      setTimeout(() => {
        this.layerList = this.layerSearchList.filter((item) => this.filterKeyword(item, name));
      }, 500);
    },
    filterKeyword(item, name) {
      const keyArr = ["layerName"];
      let flag = false;
      while (keyArr[0] && !flag) {
        if (item[keyArr.shift()].includes(name)) flag = true;
      }
      return flag;
    },
    selectionChangeLayer(val) {
      this.layerGouList = val;
    },
    async addtukaungtable() {
      const { data } = await layerDetachFileService.categoriesList(this.currentSpecId, this.enterpriseId, this.currentNodeData.id);
      this.layerList = data;
      this.layerSearchList = data;
    },
    async fetchData() {
      if (this.currentNodeData) {
        this.loading = true;
        const { data } = await layerDetachFileService.getListByRuleId(this.currentNodeData.id);
        this.tableData = data || [];
        this.loading = false;
      }
    },
    emptyTableData() {
      this.tableData = [];
    },

    async delLayer() {
      await this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false
      });
      const arr = [];
      for (var i = 0; i < this.selectlayers.length; i++) {
        arr.push(this.selectlayers[i].layerId);
      }
      var data = {
        layerIdList: arr,
        ruleId: this.currentNodeData.id
      };
      await layerDetachFileService.layerDeleteList(data);
      this.fetchData();
      this.selectlayers = [];
      this.$message.success("删除成功");
    },

    handleSelectionChange(val) {
      this.selectlayers = val;
    },

    handleNodeChange({ data }) {
      if (data.ruleName) {
        this.currentNodeData = data;
        this.currentSpecId = data.specId;
      } else {
        this.currentNodeData = null;
        this.currentSpecId = data.specId;
      }
    },

    async addLayer() {
      this.visible = true;
      this.layerGouList = [];
      await this.$nextTick();
      this.$refs.multipleTable.clearSelection();
      this.layerSearchInput = "";
      this.addtukaungtable();
    },

    async submit() {
      const arr = [];
      for (var i = 0; i < this.layerGouList.length; i++) {
        arr.push(this.layerGouList[i].layerId);
      }
      var data = {
        layerIdList: arr,
        ruleId: this.currentNodeData.id
      };
      await layerDetachFileService.layerAddList(data);
      this.fetchData();
      this.visible = false;
      this.$message.success("图层创建成功");
    }
  }
};
</script>

<style lang="scss" scoped>
.layer-detach-file {
  height: 100%;

  .el-aside {
    overflow: hidden;
    margin-right: 10px;
    background: #fff;
  }

  .el-main {
    background: #fff;
    height: 100%;
    .top {
      height: 48px;
      border-bottom: 1px solid #ebefff;

      * {
        margin-right: 10px;
      }
    }

    .content {
      height: calc(100% - 60px);
      margin-top: 10px;
    }
  }
}
</style>
